/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTablet: {
  name: 'tablet';
  data: string;
} = {
  name: 'tablet',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 4A1.5 1.5 0 0 1 2 2.5h12A1.5 1.5 0 0 1 15.5 4v8a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 12V4Zm7 8.5H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5H7.5v9Zm-1-9v9H2a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5h4.5ZM5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor"/></svg>`,
};
